// extracted by mini-css-extract-plugin
export default {"container":"skinnyPhotos_container__Jx7Hh","wrapper":"skinnyPhotos_wrapper__Rk7xw","box1":"skinnyPhotos_box1__IjAgT","box2":"skinnyPhotos_box2__KBxic"};